import React, { useState, useRef } from 'react';
import CostBreakdownTooltip from './CostBreakdownTooltip';

const TotalCostCell = ({ value, row }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [hoverTimeout, setHoverTimeout] = useState(null);
  const cellRef = useRef(null);

  const handleMouseEnter = () => {
    // Clear any existing timeout
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
    }
    
    // Show tooltip after a short delay
    const timeout = setTimeout(() => {
      setShowTooltip(true);
    }, 300);
    
    setHoverTimeout(timeout);
  };

  const handleMouseLeave = () => {
    // Clear timeout and hide tooltip after a delay
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
    }
    
    const timeout = setTimeout(() => {
      setShowTooltip(false);
    }, 100);
    
    setHoverTimeout(timeout);
  };

  const handleTooltipMouseEnter = () => {
    // Keep tooltip visible when hovering over it
    if (hoverTimeout) {
      clearTimeout(hoverTimeout);
    }
  };

  const handleTooltipMouseLeave = () => {
    // Hide tooltip when leaving tooltip area
    setShowTooltip(false);
  };

  const handleTooltipClick = () => {
    // Pricing Drawer is opened by the wrapper div click handler in catalog.js
    // This tooltip click just closes the tooltip
    setShowTooltip(false);
  };

  // Format the total cost value
  const formatCost = (cost) => {
    if (cost === null || cost === undefined || isNaN(cost)) {
      return '$--';
    }
    return `$${parseFloat(cost).toFixed(2)}`;
  };

  const totalCost = row.total_cost || value || 0;
  const hasCostData = totalCost > 0;

  const handleCalcNeeded = (e) => {
    e.stopPropagation(); // Prevent row click
    // Trigger cost calculation for this product
    console.log('Triggering cost calculation for:', row.sku);
    // This would integrate with the calculation API
  };

  return (
    <div className="relative">
      {hasCostData ? (
        <div
          ref={cellRef}
          className="cursor-help hover:bg-gray-50 dark:hover:bg-gray-700 px-2 py-1 rounded transition-colors"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          title="Hover for cost breakdown"
        >
          <span className="text-sm font-mono">
            {formatCost(totalCost)}
          </span>
          <span className="ml-1 text-xs text-gray-400">
            ℹ️
          </span>
        </div>
      ) : (
        <button
          onClick={handleCalcNeeded}
          className="px-2 py-1 text-xs bg-blue-50 text-blue-600 hover:bg-blue-100 border border-blue-200 rounded-md transition-colors"
          title="Click to calculate costs"
        >
          Calc Needed
        </button>
      )}
      
      <CostBreakdownTooltip
        row={row}
        isVisible={showTooltip}
        onMouseEnter={handleTooltipMouseEnter}
        onMouseLeave={handleTooltipMouseLeave}
        onClick={handleTooltipClick}
        triggerRef={cellRef}
      />
    </div>
  );
};

export default TotalCostCell;